<template>
  <div class="container-fluid vertical-spacing locations">
    <div class="row center-xs">
      <div class="col-xs-12 col-md-3"
        v-for="location in branchOffices"
        :key="location.Id"
      >
        <div class="item">
          <SfLink target="_blank" :link="location.Url || defaultUrl">
            <div class="image-container">
              <SfImage
                v-if="location.ImageUrl"
                :src="pictureUrlPath(location.ImageUrl)"
                :alt="location.Name"
                :lazy="true"
              />
              <SfImage v-else :src="logo" :alt="location.Name" :lazy="true" class="image-no" />
            </div>
          </SfLink>
          <SfLink target="_blank" :link="location.Url || defaultUrl"
          class="location">{{ location.Name }}</SfLink>
          <SfLink
            v-if="location.Address.Email"
            :link="`mailto:${location.Address.Email}`"
            class="email"
          >
            {{ location.Address.Email }}
          </SfLink>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SfLink, SfImage } from '@storefront-ui/vue';
import logo from '@/assets/logo.svg';
import { config } from '@/modules/core';

export default {
  name: 'Locations',
  mixins: [config],
  components: {
    SfLink,
    SfImage,
  },
  data() {
    return {
      logo,
      defaultUrl: 'https://www.bmw-zdunek.pl/',
    };
  },
  computed: {
    branchOffices() {
      return this.warehouses.filter((warehouse) => warehouse.IsBranchOffice);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.item {
  @include flexbox-mobile {
    max-width: 320px;
  }
  margin: var(--spacer-sm) auto;
  padding: var(--spacer-sm);
  text-align: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  &:nth-child(2) {
    margin: 0 var(--spacer-sm);
  }
}

.sf-link {
  text-decoration: none;
  display: block;
}

.location {
  font: var(
    --heading-title-font,
    var(--heading-title-font-weight, var(--font-semibold))
      var(--heading-title-font-size, var(--h4-font-size)) /
      var(--heading-title-font-line-height, 1.6)
      var(--heading-title-font-family, var(--font-family-secondary))
  );
  padding: var(--spacer-xs) 0;
  text-transform: uppercase;
}

.email {
  font: var(
    --heading-title-font,
    var(--heading-title-font-weight, var(--font-light))
      var(--heading-title-font-size, var(--h5-font-size)) /
      var(--heading-title-font-line-height, 1.6)
      var(--heading-title-font-family, var(--font-family-secondary))
  );
}

.image-container {
  @include flexbox-mobile {
    height: 200px;
  }
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: var(--spacer-xs);
}

.sf-image {
  &:not(.image-no) /deep/ img {
    transition: transform 0.2s;
    opacity: 0.9;
    &:hover {
      transform: scale(1.2);
      opacity: 1;
    }
  }
  &.image-no /deep/ img {
    max-width: 100px;
    opacity: 0.7;
  }
}

.row > div {
  @include flexbox-desktop {
    display: flex;
  }
}

</style>
